import { gql } from "@apollo/client";

export const CREATE_SHIELD_MUTATION = gql`
    mutation CreateShieldMutation($imageData: String!, $shieldMateId: ID) {
        createShield(imageData: $imageData, shieldMateId: $shieldMateId) {
            success
            message
            shield {
                id
                imageUrl
                createdAt
                shieldNumber {
                    number
                }
                updatedAt
            }
        }
    }
`;

export const CREATE_SHIELD_TWO_MUTATION = gql`
    mutation CreateShieldTwoMutation($imageData: String!) {
        createShieldTwo(imageData: $imageData) {
            success
            message
            shieldTwo {
                id
                imageUrl
                createdAt
                shieldNumber {
                    number
                }
                updatedAt
            }
        }
    }
`;

export const CREATE_RUNESTONE_MUTATION = gql`
    mutation CreateRunestoneMutation($imageData: String!, $runeName: String!) {
        createRunestone(imageData: $imageData, runeName: $runeName) {
            success
            message
            runestone {
                id
                imageUrl
                runeName
                createdAt
            }
        }
    }
`;
